import { apiConfig } from "./apiConfig";
import {getNblyApiHeaders} from './getNblyApiHeaders';
export function getRefDetails(){
    var leadSourceNames: any[] = [];
    //var refrenceVal = window.objOSGlobal.requestBodyValues?.ConceptCalledId == "1" ? $('#reference-details :selected').val() : $('#sd-reference-details :selected').val();
    //if(refrenceVal!=""){
    //     return;
    //    }
    //}else{}
    let FranchiseId:any = window.objOSGlobal.requestBodyValues.FranchiseId ? "&franchiseId=" + window.objOSGlobal.requestBodyValues.FranchiseId : "";
        $('.reference-details').empty();
        $.ajax({
            url: `${apiConfig.genericLeadSources}?apikey=${window.DEFINE_VALUE.JS_API_KEY}`+"&"+getNblyApiHeaders()+FranchiseId,
            type: "GET",
            success: function (data: any)
            {
                window.objOSGlobal.requestBodyValues.genericLeadSourcesObjData = data;
                $.each(data, function (index: any, element: any)
                {
                    leadSourceNames.push(`<option id="${element.syncGenericLeadSourceId}" value="${element.syncGenericLeadSourceId}">${element.leadSourceName}</option>`)
                });
                $('.reference-details').append(leadSourceNames);
                $('.reference-details').prepend("<option value=''>Where did you hear about us?</option>").val('');
            },
            error:function(e: any) {
            }
        });
}